module.exports = __webpack_public_path__ + "img/playlist.9aac3cfc.svg";